// align with myaccountott get-started
export const getUrlParameter = (name: string) => {
  name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  const results = regex.exec(window.location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

type IUtmParam = {
  src: string;
  utm_source: string;
  utm_medium: string;
  utm_campaign: string;
  utm_content: string;
}

export const appendUtmParams = (url: string) => {
  const utmParams:IUtmParam = {
    src: getUrlParameter('src'),
    utm_source: getUrlParameter('utm_source'),
    utm_medium: getUrlParameter('utm_medium'),
    utm_campaign: getUrlParameter('utm_campaign'),
    utm_content: getUrlParameter('utm_content')
  };
  const params = Object.keys(utmParams).map((k) =>  {
    return encodeURIComponent(k) + '=' +  encodeURIComponent(utmParams[k as keyof typeof utmParams])

  }).join('&')
 return url + (url.indexOf('?') !== -1 ? '&' : '?') + params;
}